import { SignupPage } from "@cavort/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

// `invite` is optional so `navigate({ to: "/signup" })` needs no `search`.
const searchSchema = z.object({
	invite: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/signup")({
	validateSearch: searchSchema,
	component: SignupRoute,
});

function SignupRoute() {
	const { invite } = Route.useSearch();
	const navigate = useNavigate();

	return (
		<SignupPage
			inviteToken={invite}
			onSuccess={() => navigate({ to: "/dashboard" })}
			onLoginClick={() => navigate({ to: "/login" })}
		/>
	);
}
